import React, {useEffect, useRef, useState} from 'react'
import ProgramPreviewView from '../../views/ver_24.10/ProgramPreview.view'
import {
    CHAT_TYPE,
} from "../../utils/constants";
import {useHistory, useParams} from "react-router-dom";
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import {fetchProgramPreviewService, fetchProgramSessionService} from "../../services/program.service";


const ProgramPreview = () => {
    const { programId } = useParams();
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [chatHistory, setChatHistory] = useState([]);
    const [programData, setProgramData] = useState({});
    const [unitsData, setUnitsData] = useState([]);
    const [sessionsData, setSessionsData] = useState([]);
    const [modulesData, setModulesData] = useState([]);
    const isFetchingRef = useRef(false);

    const fetchProgramPreview = async (isInitial) => {
        try {
            if (isInitial) {
                setShowLoader(true);
            }
            if (programId) {
                const result = await fetchProgramPreviewService(programId);
                if (result.data) {
                    setProgramData(result.data.programData);
                    setModulesData(result.data.modulesData);
                    setUnitsData(result.data.unitsData);
                    // setSessionsData(result.data.sessionsData);
                }
            }
        } catch (error) {
            if (isInitial) {
                setShowLoader(false);
            }
            console.error('Failed to fetch program preview:', error);
        } finally {
            if (isInitial) {
                setShowLoader(false);
            }
        }
    };

    useEffect(() => {

        const fetchIfNeeded = async () => {
            if (modulesData.length === 0) {
                await fetchProgramPreview(true);
                return;
            }

            const allLessonsExist = modulesData.every(module =>
                module.units.every(unit =>
                    unit.lessons.every(lesson => lesson.exists === true)
                )
            );

            if (!allLessonsExist && !isFetchingRef.current) {
                isFetchingRef.current = true;
                await fetchProgramPreview(false);
                setTimeout(() => {
                    isFetchingRef.current = false;
                }, 5000);
            }
        };

        fetchIfNeeded().then(r => console.log(r));

        const interval = setInterval(() => {
            fetchIfNeeded().then(r => console.log(r));
        }, 10000);

        return () => clearInterval(interval);
    }, [programId, modulesData]);

    const data = {
        programData,
        unitsData,
        sessionsData,
        modulesData,
        chats: chatHistory
    };

    const options={
        height: '210px',
        bottom:'6%',
        chatType: 'programPreviewSlides',
    };

    const actions={
        sendMessageAction: (message) => {
            setChatHistory((prevChatHistory) => [
                ...prevChatHistory,
                { type: CHAT_TYPE.USER, text: message },
            ]);

            return new Promise((resolve) => {
                setTimeout(() => {
                    let responseData;

                    setChatHistory((prevChatHistory) => {
                        const updatedChatHistory = [...prevChatHistory];

                        const chatLength = updatedChatHistory.filter(
                            (msg) => msg.type === CHAT_TYPE.USER
                        ).length;

                        switch (chatLength) {
                            case 1:
                                responseData = {
                                    response_message: 'Do you know its consequences?',
                                };
                                break;
                            case 2:
                                const lastUserMessage = message.toLowerCase().trim();
                                if (lastUserMessage === 'yes') {
                                    responseData = {
                                        response_message:
                                            'Great! Can you tell me more about what you know?',
                                    };
                                } else if (lastUserMessage === 'no') {
                                    responseData = {
                                        response_message:
                                         'No worries, I can guide you through the consequences.',
                                    };
                                } else {
                                    responseData = {
                                        response_message: 'Please answer with yes or no.',
                                    };
                                }
                                break;
                            case 3:
                                responseData = {
                                    response_message: 'Your program outline has been updated!',
                                    programId: 'programId123',
                                };
                                break;
                            case 4:
                            default:
                                responseData = {
                                    response_message: 'Thank you for using our service!',
                                };
                                break;
                        }

                        updatedChatHistory.push({
                            type: CHAT_TYPE.BOT,
                            text: responseData.response_message,
                        });


                        resolve({ data: responseData });
                        if (responseData.programId) {
                            setShowLoader(true);
                            setTimeout(() => {
                                history.push(`/program/${programId}/dashboard`);
                            }, 2000);
                        }
                        return updatedChatHistory;
                    });
                }, 1000);
            });
        },
        fetchSessionAction: async (lesson_code) => {
            try {
                const result = await fetchProgramSessionService(lesson_code);
                if (result.data) {
                    setSessionsData(result.data.sessionsData);
                }
            } catch (e) {

            }
        },
        exitProgramAction: () => {
            history.push(`/program/${programId}/dashboard`);
        }
    }

    if (showLoader) {
        return <Loader />;
    }
    return (
        <>
            <ProgramPreviewView data={data} options={options} actions={actions}/>
        </>
    );
}

export default ProgramPreview;